import { get, post, put } from '../../api';
import { ansiToMoment } from '@utils';

export const getHeadersSelect = async (idConfiguracao = -1) => {
  const res = await get(`/api/conectores/headers/${idConfiguracao}`);

  return res.map((item) => ({
    key: `${item.id}-${item.nmHeader}`,
    value: item.id,
    title: item.nmHeader,
  }));
};

export const getHeaders = (idConfiguracao) => {
  return get(`/api/conectores/headers/${idConfiguracao}`);
};

export const getHeader = async (idConfiguracao, id) => {
  const res = await get(`/api/conectores/header/${idConfiguracao}/${id}`);

  // eslint-disable-next-line
  res.map((header) => {
    header.dtBase = ansiToMoment(header.dtBase);
  });

  return res;
};

export const postHeader = (data) => {
  return post('/api/conectores/header', data);
};

export const putHeader = (data) => {
  return put('/api/conectores/header', data);
};
